.root {
  position: relative;
}

.input {
  width: 100%;
  height: 30px;
  margin: 10px 0;
  appearance: none;
  background: transparent;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: var(--primary-light);
    border-width: 0;
    border-radius: 0;
    box-shadow: none;
    /* animate: 0.2s; */
  }

  &::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: var(--primary-light);
    border-width: 0;
    border-radius: 0;
    box-shadow: none;
  }

  &::-moz-range-thumb {
    width: 50px;
    height: 22px;
    cursor: pointer;
    background: var(--menu-background);
    border: 1px solid var(--primary);
    border-radius: 4px;
    box-shadow: none;
  }

  &::-webkit-slider-thumb {
    width: 50px;
    height: 24px;
    margin-top: -10px;
    appearance: none;
    cursor: pointer;
    background: var(--menu-background);
    border: 1px solid var(--primary);
    border-radius: 4px;
    box-shadow: none;
  }

  &:focus::-webkit-slider-runnable-track {
    background: var(--primary-light);
  }

  &::-ms-track {
    width: 100%;
    height: 4px;
    color: transparent;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
  }

  &::-ms-fill-lower {
    background: var(--primary);
    border-width: 0;
    border-radius: 10px;
    box-shadow: none;
  }

  &::-ms-fill-upper {
    background: var(--primary);
    border-width: 0;
    border-radius: 10px;
    box-shadow: none;
  }

  &::-ms-thumb {
    width: 50px;
    height: 24px;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid var(--primary);
    border-radius: 4px;
    box-shadow: none;
  }

  &:focus::-ms-fill-upper,
  &:focus::-ms-fill-lower {
    background: var(--primary);
  }
}

.faux {
  position: absolute;
  top: 50%;
  width: 50px;
  height: 24px;
  line-height: 24px;
  color: var(--primary);
  pointer-events: none;
}
